const { PATH: APP_PATH } = require('./appPaths')

// Legacy underscore aliases. Express 301s these; React still redirects
// because webpack-dev-server never hits that 301.
const PATH = {
	SELECT_YOUR_MEMBERSHIP: '/select_your_membership',
	NEW_MEMBER_QUESTIONNAIRE: '/new_member_questionnaire',
	TRAILER_CARE: '/trailer_care',
}

const LEGACY_PATH_MAP = [
	[PATH.SELECT_YOUR_MEMBERSHIP, APP_PATH.SELECT_YOUR_MEMBERSHIP],
	[PATH.NEW_MEMBER_QUESTIONNAIRE, APP_PATH.NEW_MEMBER_QUESTIONNAIRE],
	[PATH.TRAILER_CARE, APP_PATH.TRAILER_CARE],
]

function resolvePathname(pathname) {
	if (!pathname) return pathname
	return LEGACY_PATH_MAP.reduce(
		(result, [legacy, current]) => result.replace(legacy, current),
		pathname,
	)
}

function redirectLocation(pathname, originalUrl) {
	const nextPath = resolvePathname(pathname)
	if (!nextPath || nextPath === pathname) return null
	const queryIndex = String(originalUrl || '').indexOf('?')
	const search = queryIndex === -1 ? '' : originalUrl.slice(queryIndex)
	return `${nextPath}${search}`
}

module.exports = {
	PATH,
	resolvePathname,
	redirectLocation,
}
